// URL du serveur Keycloak, injectée au build par CRA (variables REACT_APP_*)
const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://connexion.ffr.fr/auth';

export function getConfSso(){
  // le SSO 26 (sso-26.ffr2.nextmap.cloud) est branché sur le site de dev, les autres sur la pp
  const conf = {
    urlEspacePrive: /sso-?26/.test(SSO_URL)
      ? 'https://dev.website.ffr.nextmap.io/tableau-de-bord'
      : 'https://pp.website.ffr.nextmap.io/tableau-de-bord'
  };

  if (process.env.NODE_ENV === 'production') {
    let hostname = 'site-temoin.ffr.fr';
    if (typeof window !== "undefined" && window && window.location && window.location.hostname !== 'localhost') {
      hostname = window.location.hostname;
    }
    
    const clubId = hostname.split('.')[0];
    const source = hostname.split('.').splice(1).join('.');

    // pp (ffr.nextmap.io, ffr2.nextmap.cloud, site témoin) : on reste sur l'espace privé de pp (ou de dev pour le SSO 26)
    if (
      source !== 'ffr.nextmap.io' &&
      source !== 'ffr2.nextmap.cloud' &&
      clubId !== 'site-temoin' &&
      clubId !== 'liguetest'
    ) {
      conf.urlEspacePrive = 'https://www.ffr.fr/tableau-de-bord';
    }
  }
  return conf;
} 

export function getInitSsoOptions() {
  let ssoOptions =  {
    url: SSO_URL,
    realm: "FFRpp",
    clientId: "ffr_ligues_pp",
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  };
  
  if (process.env.NODE_ENV === 'production') {
    let hostname = 'site-temoin.ffr.fr';
    if (typeof window !== "undefined" && window && window.location && window.location.hostname !== 'localhost') {
      hostname = window.location.hostname;
    }
    
    const clubId = hostname.split('.')[0];
    const source = hostname.split('.').splice(1).join('.');

    if (source !== 'ffr.nextmap.io' && clubId !== 'site-temoin' && clubId !== 'liguetest') {
      ssoOptions.realm = 'FFR';
      ssoOptions.clientId = 'ffr_clubs';
    }
  }

  return ssoOptions;
}